import { ButtonIcon } from '@/app/common';

interface GalleryDesktopArrowsProps {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
}

export const GalleryDesktopArrows = ({
  canScrollLeft,
  canScrollRight,
  onScrollLeft,
  onScrollRight,
}: GalleryDesktopArrowsProps) => {
  return (
    <div className="hidden md:flex flex-row justify-start gap-sm">
      <ButtonIcon variant="icon" iconName="ChevronLeft" isDisabled={!canScrollLeft} onClick={onScrollLeft} />
      <ButtonIcon variant="icon" iconName="ChevronRight" isDisabled={!canScrollRight} onClick={onScrollRight} />
    </div>
  );
};
